// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2_SZd","head":"Table_head__3sx_s","col":"Table_col__ZRAsJ"};